import React from 'react';
import PropTypes from 'prop-types';
import { FixedSizeList as List } from 'react-window';

const height = 40;
const maxHeight = 300;

function getListHeight(itemCount) {
  return Math.min(itemCount * height, maxHeight);
}

function MenuList({
  options, children, getValue,
}) {
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * height;

  return (
    <List
      height={getListHeight(children.length)}
      itemCount={children.length}
      itemSize={height}
      initialScrollOffset={initialOffset}
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
}

MenuList.propTypes = {
  options: PropTypes.array.isRequired,
  children: PropTypes.array.isRequired,
  getValue: PropTypes.func.isRequired,
};

export default MenuList;
